






















































import {Component, Prop} from 'vue-property-decorator';
import {Store} from '@/enums/Store';
import {Event} from '@/util/Event';
import MemberForm from '@/components/Member/MemberForm.vue';
import LocationForm from '@/components/Location/LocationForm.vue';
import BillingForm from '@/components/Billing/BillingForm.vue';
import Validatable from '@/components/Validatable.vue';
import EventInfo from '@/components/Event/EventInfo.vue';
import Overview from '@/components/Overview/Overview.vue';
import {namespace} from 'vuex-class';
import {Step} from '@/enums/Step';
import {Response} from '@/util/Response';
import {Currency} from '@/enums/Currency';
import {Init, InitPayload} from '@/store/app';
import {Locale} from '@/enums/Locale';

const APP = namespace(Store.APP);
const CART = namespace(Store.CART);
const EVENT = namespace(Store.EVENT);

@Component({
  components: {
    Overview,
    EventInfo,
    LocationForm,
    MemberForm,
    BillingForm
  }
})
export default class StepWrapper extends Validatable {
  @APP.Getter('currentStep') currentStep!: string | false;
  @APP.Mutation('ADD_ERROR') addError!: (error: Error) => void;
  @APP.Action('incrementStep') incrementStep!: () => void;
  @APP.Action('decrementStep') decrementStep!: () => void;
  @CART.Action('init') init!: Init;
  @APP.State('currency') currency!: Currency;
  @APP.State('storeId') storeId!: number;
  @APP.State('promoterId') promoterId!: number;
  @CART.Getter('response') response!: Response;
  @CART.State('orderId') orderId?: number | string;
  @CART.Mutation('SET_ORDER_ID') setOrderId!: (orderId: string | number) => void;
  @EVENT.Getter('selectedEventObject') event!: Event;
  @CART.Action('setShowDiscountResetButton') setShowDiscountResetButton!: (
    value: boolean
  ) => void;
  @Prop() locale?: Locale;

  showEventInfo = false;
  isPayButtonDisabled = false;
  result: any = null;
  discountError: any = null;
  hasDiscountError = false;

  async next() {
    await this.init(
      new InitPayload(this.locale, this.promoterId, this.storeId, this.currency)
    );
    const validationResult = await this.validate();

    if (validationResult) {
      if (this.currentStep == Step.MEMBER_FORM) {
        try {
          this.discountError = undefined;
          this.hasDiscountError = false;

          const memberList = this.response.memberList;

          const result = await this.$api.post<{ memberList: any }>(
            '/discount/check/all',
            this.response,
            undefined,
            false
          );
        } catch (error) {
          this.discountError = error.response;
          this.hasDiscountError = true;
          this.addError(error);
          this.setShowDiscountResetButton(true);
        }
      }

      if (this.currentStep == Step.BILLING_FORM) {
        try {
          this.isPayButtonDisabled = true;
          const result = await this.$api.post<{ incrementId: number }>(
            '/orders',
            this.response,
            undefined,
            false
          );

          this.setOrderId(result.incrementId);

          if (this.orderId != undefined) {
            this.incrementStep();
          }
        } catch (error) {
          this.addError(error);
        }
      } else {
        if (!this.discountError) {
          this.incrementStep();
        }
      }
    }
  }

  get autoDiscountMarketingText() {
     return this.event.ticketCategories[0].autoDiscountMarketingText;
  }

  get buttonText() {
    if (this.currentStep == Step.BILLING_FORM) {
      return '  Verbindlich anmelden';
    } else {
      return '  weiter';
    }
  }

  get subHeaderText() {
    if (this.currentStep == Step.BILLING_FORM) {
      return 'Rechnungsempfänger';
    } else {
      return 'Teilnehmer anmelden';
    }
  }
}
